var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialShareWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7197 11.2601C11.0664 10.9468 11.5197 10.7468 12.0264 10.7468C13.0997 10.7468 13.973 11.6201 13.973 12.6934C13.973 13.7668 13.0997 14.6401 12.0264 14.6401C10.953 14.6401 10.0797 13.7668 10.0797 12.6934C10.0797 12.5468 10.0997 12.4001 10.133 12.2601L5.38637 9.48677C5.02637 9.82011 4.55303 10.0268 4.02637 10.0268C2.9197 10.0268 2.02637 9.13344 2.02637 8.02677C2.02637 6.92011 2.9197 6.02677 4.02637 6.02677C4.55303 6.02677 5.02637 6.23344 5.38637 6.56677L10.0864 3.82677C10.053 3.67344 10.0264 3.52011 10.0264 3.36011C10.0264 2.25344 10.9197 1.36011 12.0264 1.36011C13.133 1.36011 14.0264 2.25344 14.0264 3.36011C14.0264 4.46677 13.133 5.36011 12.0264 5.36011C11.4997 5.36011 11.0264 5.15344 10.6664 4.82011L5.96637 7.56011C5.9997 7.71344 6.02637 7.86677 6.02637 8.02677C6.02637 8.18677 5.9997 8.34011 5.96637 8.49344L10.7197 11.2601ZM12.693 3.36011C12.693 2.99344 12.393 2.69344 12.0264 2.69344C11.6597 2.69344 11.3597 2.99344 11.3597 3.36011C11.3597 3.72677 11.6597 4.02677 12.0264 4.02677C12.393 4.02677 12.693 3.72677 12.693 3.36011ZM4.02637 8.69344C3.6597 8.69344 3.3597 8.39344 3.3597 8.02677C3.3597 7.66011 3.6597 7.36011 4.02637 7.36011C4.39303 7.36011 4.69303 7.66011 4.69303 8.02677C4.69303 8.39344 4.39303 8.69344 4.02637 8.69344ZM11.3597 12.7068C11.3597 13.0734 11.6597 13.3734 12.0264 13.3734C12.393 13.3734 12.693 13.0734 12.693 12.7068C12.693 12.3401 12.393 12.0401 12.0264 12.0401C11.6597 12.0401 11.3597 12.3401 11.3597 12.7068Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialShareWhite);
export default __webpack_public_path__ + "static/media/social-share-white.11c0356afde025822cb1b2e4ce69adba.svg";
export { ForwardRef as ReactComponent };